import { render, staticRenderFns } from "./HorizontalScrollbar.vue?vue&type=template&id=b13fd080&scoped=true&"
import script from "./HorizontalScrollbar.vue?vue&type=script&lang=js&"
export * from "./HorizontalScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalScrollbar.vue?vue&type=style&index=0&id=b13fd080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13fd080",
  null
  
)

export default component.exports